import { IconFileDollar, IconInvoice, IconShoppingCart } from '@tabler/icons-react';
import { i18nKeys, useTranslation } from 'locales';
import { useMemo } from 'react';
import { useCanUseManualActions } from 'shared/utils/connector';

import type { Menu, MenuItem } from '../types';

export function useBuildInvoiceMenu(): Menu {
  const { t } = useTranslation();
  const hasManualActionsActive = useCanUseManualActions();

  return useMemo(() => {
    const items: Array<Menu | MenuItem> = [
      {
        path: '/invoices',
        label: t(i18nKeys.NAV.INVOICES),
        Icon: IconFileDollar,
        isExactRouteMatch: false,
      },
      {
        path: '/credit-notes',
        label: t(i18nKeys.NAV.CREDIT_NOTES),
        Icon: IconInvoice,
        isExactRouteMatch: false,
      },
      {
        path: '/products',
        label: t(i18nKeys.NAV.PRODUCTS),
        Icon: IconShoppingCart,
        isHidden: !hasManualActionsActive,
      },
    ];

    return {
      parent: null,
      label: t(i18nKeys.COMMON.INVOICING),
      Icon: IconFileDollar,
      path: '/invoices',
      items,
    };
  }, [hasManualActionsActive, t]);
}
